/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DutyScheduleDisplayStatus } from './DutyScheduleDisplayStatus';
import {
    DutyScheduleDisplayStatusFromJSON,
    DutyScheduleDisplayStatusFromJSONTyped,
    DutyScheduleDisplayStatusToJSON,
    DutyScheduleDisplayStatusToJSONTyped,
} from './DutyScheduleDisplayStatus';

/**
 * 
 * @export
 * @interface DutyScheduleResponse
 */
export interface DutyScheduleResponse {
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleResponse
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleResponse
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleResponse
     */
    periodEnd: Date;
    /**
     * 
     * @type {DutyScheduleDisplayStatus}
     * @memberof DutyScheduleResponse
     */
    status: DutyScheduleDisplayStatus;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleResponse
     */
    workingDays: number | null;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleResponse
     */
    dutyCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof DutyScheduleResponse
     */
    counselorCount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleResponse
     */
    lastModifiedAtUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleResponse
     */
    lastModifiedByUserCode: string;
}



/**
 * Check if a given object implements the DutyScheduleResponse interface.
 */
export function instanceOfDutyScheduleResponse(value: object): value is DutyScheduleResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('periodStart' in value) || value['periodStart'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('workingDays' in value) || value['workingDays'] === undefined) return false;
    if (!('dutyCount' in value) || value['dutyCount'] === undefined) return false;
    if (!('counselorCount' in value) || value['counselorCount'] === undefined) return false;
    if (!('lastModifiedAtUtc' in value) || value['lastModifiedAtUtc'] === undefined) return false;
    if (!('lastModifiedByUserCode' in value) || value['lastModifiedByUserCode'] === undefined) return false;
    return true;
}

export function DutyScheduleResponseFromJSON(json: any): DutyScheduleResponse {
    return DutyScheduleResponseFromJSONTyped(json, false);
}

export function DutyScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'periodStart': (new Date(json['periodStart'])),
        'periodEnd': (new Date(json['periodEnd'])),
        'status': DutyScheduleDisplayStatusFromJSON(json['status']),
        'workingDays': json['workingDays'],
        'dutyCount': json['dutyCount'],
        'counselorCount': json['counselorCount'],
        'lastModifiedAtUtc': (new Date(json['lastModifiedAtUtc'])),
        'lastModifiedByUserCode': json['lastModifiedByUserCode'],
    };
}

export function DutyScheduleResponseToJSON(json: any): DutyScheduleResponse {
    return DutyScheduleResponseToJSONTyped(json, false);
}

export function DutyScheduleResponseToJSONTyped(value?: DutyScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'periodStart': `${value['periodStart'].getFullYear()}-${String(value['periodStart'].getMonth()+1).padStart(2,'0')}-${String(value['periodStart'].getDate()).padStart(2,'0')}`,
        'periodEnd': `${value['periodEnd'].getFullYear()}-${String(value['periodEnd'].getMonth()+1).padStart(2,'0')}-${String(value['periodEnd'].getDate()).padStart(2,'0')}`,
        'status': DutyScheduleDisplayStatusToJSON(value['status']),
        'workingDays': value['workingDays'],
        'dutyCount': value['dutyCount'],
        'counselorCount': value['counselorCount'],
        'lastModifiedAtUtc': value['lastModifiedAtUtc'].toISOString(),
        'lastModifiedByUserCode': value['lastModifiedByUserCode'],
    };
}

